export function isNullOrWhitespace(input: string | undefined | null): boolean {
  if (input === null || input === undefined) {
    return true;
  }

  if (typeof input !== 'string') {
    input = '' + input;
  }

  return input.trim() === '';
}
